module.exports = true;


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/$.library.js
 ** module id = 389
 ** module chunks = 0
 **/